import { NgTemplateOutlet } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    inject,
    input,
    Renderer2
} from '@angular/core';

@Component({
    selector: 'tran-pill-cell',
    imports: [NgTemplateOutlet],
    templateUrl: './pill-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'w-full md:flex-1'
    }
})
export class PillCellComponent implements AfterViewInit {
    private readonly elementRef = inject(ElementRef);
    private readonly renderer = inject(Renderer2);

    public readonly bgColor = input<string>('bg-deep-blue-725');
    public readonly textColor = input<string>('text-white');
    public readonly disabled = input<boolean>(false);

    protected readonly cellClasses = computed(() => {
        const base = `relative text-center text-xs md:text-sm flex items-center justify-start h-full pl-4 md:pl-10 pr-4 md:pr-10 rounded-[15px]`;
        const colors = `${this.bgColor()} ${this.textColor()}`;

        if (this.disabled()) {
            return `${base} ${colors} text-white/60 before:absolute before:inset-0 before:bg-black/30 before:rounded-[15px]`;
        }

        return `${base} ${colors}`;
    });

    ngAfterViewInit(): void {
        setTimeout(() => {
            const parentElement = this.elementRef.nativeElement.parentElement;
            const direction = parentElement?.getAttribute('data-overlap-direction') || 'ltr';

            const allCells = Array.from(parentElement?.children || []);
            const currentIndex = allCells.indexOf(this.elementRef.nativeElement);
            const totalCells = allCells.length;

            const hostElement = this.elementRef.nativeElement;

            if (direction === 'ltr') {
                this.renderer.setStyle(hostElement, 'z-index', totalCells - currentIndex);
                const isFirst = currentIndex === 0;
                if (!isFirst) {
                    this.renderer.addClass(hostElement, '-ml-2');
                    this.renderer.addClass(hostElement, 'md:-ml-4');
                }
            } else {
                this.renderer.setStyle(hostElement, 'z-index', currentIndex + 1);
                const isLast = currentIndex === totalCells - 1;
                if (!isLast) {
                    this.renderer.addClass(hostElement, '-mr-2');
                    this.renderer.addClass(hostElement, 'md:-mr-4');
                }
            }
        }, 0);
    }
}
